<template lang="pug">
  .c-bananas-widget(v-scroll="scrollVisible")
    div(v-if="mvTranslate" :id="'c-translation-' + parentIndex")
    .c-translation-overlay(v-if="translationOpen")
      .c-translation-content
        .c-translation-form
          .c-translation-headline Translation
          .c-translation-label Key
          .c-translation-key {{ translationKey }}
          .c-translation-label Old Value
          .c-translation-old {{ translationOldValue }}
          .c-translation-label New Value
          input.c-translation-new(v-model="newValue")
          .c-translation-button-line
            .c-translation-cancel(@click="closeTranslation") Cancel
            .c-translation-approved
              .c-translation-approved-btn(@click="saveTranslation") Save
    .c-bananas-widget__loop.c-bananas-widget--fade
      .c-offercard__wrapper
        .c-offercard
          .c-offercard__image(:style="{backgroundImage: 'url('+ offer.image +')'}")
          .c-offercard__info
            .c-offercard__price
              img.c-offercard__provider-image(:src="offer.tourOperator.logo" :alt="offer.tourOperator.name")
              span.c-offercard__price-prefix.c-tooltip(v-if="mvTranslate" data-translation="text.pricefrom" data-tooltip="Bananas - text.pricefrom" @click="openTranslation") {{ $t('text.pricefrom') }}
              span.c-offercard__price-prefix(v-else) {{ $t('text.pricefrom') }}
              span.c-offercard__price-value {{ offer.price.amount }}
              span.c-offercard__price-currency.c-tooltip(v-if="mvTranslate" :data-translation="'text.currency.' + offer.price.currency" :data-tooltip="'Bananas - text.currency.' + offer.price.currency" @click="openTranslation") {{$t('text.currency.' + offer.price.currency)}}
              span.c-offercard__price-currency(v-else) {{$t('text.currency.' + offer.price.currency)}}
              span.c-offercard__price-extended p.P.
            .c-offercard__category
              img.c-offercard__category-icon(src='https://s3.eu-central-1.amazonaws.com/tremo-web-assets/icons/holidays.svg')
              .c-offercard__headline {{ offer.hotel.name }}
              span.c-offercard__hotelcategory
                span.c-offercard__hotel-category-point(v-for='point in offer.hotel.category[0]')
                span.c-offercard__hotel-category-point--half(v-if='offer.hotel.category[1]')
                  span.c-offercard__hotel-category-point--half-left
                  span.c-offercard__hotel-category-point--half-right
              .c-offercard__location {{ offer.hotel.location.country }}, {{ offer.hotel.location.region }}, {{ offer.hotel.location.city }}
              .c-offercard__dates
                | {{ offer.duration }}&nbsp;
                span(v-if="mvTranslate")
                  span.c-tooltip(v-if="offer.duration > 1" data-translation="text.day.other" data-tooltip="Bananas - text.day.other" @click="openTranslation") {{ $t("text.day.other") }}&nbsp;
                  span.c-tooltip(v-else data-translation="text.day.one" :data-tooltip="text.day.one") {{ $t("text.day.one") }}&nbsp;
                span(v-else)
                  span(v-if='offer.duration > 1') {{ $t("text.day.other") }}&nbsp;
                  span(v-else) {{ $t("text.day.one") }}&nbsp;
                span | {{ offer.dates.start | formatDate }} - {{ offer.dates.end | formatDate }}
            .c-offercard__meta.c-offercard__hotel-details
              .c-offercard__hotel-details-properties
                .c-offercard__hotel-board-type
                  <svg class="c-offercard__hotel-board-type-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="none" d="M0 0h24v24H0V0z"/>
                    <path class="c-offercard__hotel-board-type-icon--path" d="M16 6v8h3v8h2V2c-2.76 0-5 2.24-5 4zm-5 3H9V2H7v7H5V2H3v7c0 2.21 1.79 4 4 4v9h2v-9c2.21 0 4-1.79 4-4V2h-2v7z"/>
                  </svg>
                  span.c-tooltip(v-if="mvTranslate" :data-translation="'text.boardtype.' + offer.boardType" :data-tooltip="'Bananas - text.boardtype.' + offer.boardType" @click="openTranslation") {{$t('text.boardtype.' + offer.boardType)}}
                  span(v-else) {{$t('text.boardtype.' + offer.boardType)}}
                .c-offercard__hotel-room-type
                  <svg class="c-offercard__hotel-room-type-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="none" d="M0 0h24v24H0V0z"/>
                    <path class="c-offercard__hotel-room-type-icon--path" d="M7 14c1.66 0 3-1.34 3-3S8.66 8 7 8s-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm12-3h-8v8H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4zm2 8h-8V9h6c1.1 0 2 .9 2 2v4z"/>
                  </svg>
                  | {{ offer.roomType }}
              .c-offercard__hotel-details-rating
                .c-offercard__meta.c-offercard__hotel-rating(v-if='offer.hotel.reviews.overall')
                  .c-offercard__hotel-rating-wrapper
                    span.c-offercard__hotel-rating-count
                      | {{ offer.hotel.reviews.count }}&nbsp;
                      span.c-tooltip(v-if="mvTranslate" data-translation="text.reviews" data-tooltip="Bananas - text.reviews" @click="openTranslation") {{ $t("text.reviews") }}
                      span(v-else) {{ $t("text.reviews") }}
                    .c-offercard__hotel-rating-container
                      <svg class="c-offercard__hotel-rating-squares">
                          <rect x="0" y="0" width="11" height="11" style="fill:#fff;fill-opacity:0;stroke-width:1;stroke:#fff" />
                          <rect x="12" width="11" height="11" style="fill:#fff;fill-opacity:0;stroke-width:1;stroke:#fff" />
                          <rect x="24" width="11" height="11" style="fill:#fff;fill-opacity:0;stroke-width:1;stroke:#fff" />
                          <rect x="36" width="11" height="11" style="fill:#fff;fill-opacity:0;stroke-width:1;stroke:#fff" />
                          <rect x="48" width="11" height="11" style="fill:#fff;fill-opacity:0;stroke-width:1;stroke:#fff" />
                          <rect x="60" width="11" height="11" style="fill:#fff;fill-opacity:0;stroke-width:1;stroke:#fff" />
                      </svg>
                      <progress class="c-offercard__hotel-rating-progress" min="0" max="100" :value="offer.hotel.reviews.recommendation + 2"></progress>
                    span.c-offercard__hotel-rating-total {{ offer.hotel.reviews.overall }} / 6.0
                  span.c-offercard__hotel-rating-recommendation(:class="{'c-offercard__hotel-rating-recommendation--red': offer.hotel.reviews.recommendation < 60, 'c-offercard__hotel-rating-recommendation--yellow': offer.hotel.reviews.recommendation >= 60, 'c-offercard__hotel-rating-recommendation--green': offer.hotel.reviews.recommendation >= 80}") {{ offer.hotel.reviews.recommendation }}%
          .c-offercard__button
            span.c-btn.c-btn--function.c-offercard__button-link.c-tooltip(v-if="mvTranslate" data-translation="button.package" data-tooltip="Bananas - button.package" @click="openTranslation") {{ $t("button.package") }}
            form(v-else action="https://rdr.holidaypirates.group/v1/link" target="_blank" method="post")
              input(type="hidden" name="config[redirect]" value="true")
              input(type="hidden" name="data[url][encoding]" value="base64_url")
              input(type="hidden" name="data[url][url]" :value="base64EncodeUnicode(offer.link + '&p=bananaIBEWidget')")
              input.c-btn.c-btn--function.c-offercard__button-link(:value='$t("button.package")' type="submit" @click='trackClick')
</template>

<script>
// import axios from 'axios'
// import settings from '@/settings/bananas'

export default {
  props: [
    'backgroundImage',
    'offer',
    'parentElement',
    'parentIndex',
    'myIndex'
  ],
  name: 'StaticIBEOffer',
  components: {},
  data() {
    return {
      tracked: false,
      trackHostNames: this.$store.getters.getTrackingHostNames,
      trackingAllowed: true,
      translationOpen: false,
      translationKey: '',
      translationOldValue: '',
      newValue: ''
    }
  },
  computed: {
    mvTranslate() {
      if (this.$store.state.hash !== undefined) {
        return this.$store.getters.getMvTranslate
      }
      return false
    }
  },
  mounted() {
    this.scrollVisible()
  },
  methods: {
    openTranslation(event) {
      this.translationOpen = true
      this.translationOldValue = event.target.innerText
      this.translationKey = event.target.attributes[0].value
    },
    closeTranslation() {
      this.translationKey = ''
      this.translationOldValue = ''
      this.newValue = ''
      this.translationOpen = false
    },
    saveTranslation() {
      /*
      axios.get(
        `${settings.translation.endpoint}?translationKey=${this.translationKey}&translationLocale=${this.$store.getters.getLocaleShort}&translationNewValue=${this.newValue}`,
        {}
      )
      const translationParts = document.querySelectorAll(
        "[data-translation='" + this.translationKey + "']"
      )
      translationParts.forEach(part => {
        part.innerText = this.newValue
      })
      */
      this.closeTranslation()
    },
    checkTrackingAllowed() {
      // Test Cookie with tracking rules
      // this.$cookies.set('tarteaucitron', '!snowplow=false!doubleclick=true!hotjar=true!googletagmanager=true!trustpilot=true!facebook=true!instagram=true!pinterest=true!twitter=true!youtube=true')
      if (this.$cookies.isKey('tarteaucitron')) {
        let trackingAllowed = this.$cookies.get('tarteaucitron')
        trackingAllowed = trackingAllowed.split('!')
        trackingAllowed = trackingAllowed[1].split('=')
        if (trackingAllowed[1] !== 'true') {
          this.trackingAllowed = false
          // Set store flag to false for tracking is allowed
          this.$store.dispatch('updateTrackingIsAllowed')
        } else {
          if (!this.trackHostNames.includes(window.location.hostname)) {
            this.trackingAllowed = false
            // Set store flag to false for tracking is allowed
            this.$store.dispatch('updateTrackingIsAllowed')
          }
        }
      }
      // Everytime true on localhost for development
      if (window.location.hostname === 'localhost') {
        this.trackingAllowed = false
        this.$store.dispatch('updateTrackingIsAllowed')
        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.toString() !== '') {
          if (urlParams.has('bn-track')) {
            if (urlParams.get('bn-track') === '1') {
              this.trackingAllowed = true
              this.$store.dispatch('setTrackingIsAllowed')
            }
          }
        }
      }
    },
    scrollVisible() {
      if (this.trackingAllowed && !this.tracked) {
        this.checkOfferVisible()
      }
    },
    getBoundingClientRect(element) {
      const {
        top,
        right,
        bottom,
        left,
        width,
        height,
        x,
        y
      } = element.getBoundingClientRect()
      return { top, right, bottom, left, width, height, x, y }
    },
    checkOfferVisible() {
      const pageCoordinates = this.getBoundingClientRect(this.$el.children[0])
      if (
        pageCoordinates.top >= 0 &&
        pageCoordinates.left >= 0 &&
        pageCoordinates.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        pageCoordinates.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      ) {
        let pageType = 'undefined'
        if (window.dataLayer.length > 0) {
          if (window.dataLayer[0].hasOwnProperty('pageType')) {
            pageType = window.dataLayer[0].pageType
          }
        }
        try {
          window.dataLayer.push({
            event: 'promoView',
            category: 'dealPromotion',
            action: 'impression',
            label: 'automated|traveltainment|package|' + this.offer.offerId, // for example 'unifiedSearch|flight'
            value: undefined,
            ecommerce: {
              promoView: {
                promotions: [
                  {
                    id: this.offer.offerId,
                    name:
                      'automated|traveltainment|' +
                      pageType +
                      '|package|' +
                      this.offer.hotel.name, // for example 'unifiedSearch|flight'
                    creative:
                      this.offer.hotel.location.country +
                      ':' +
                      this.offer.hotel.location.region +
                      ':' +
                      this.offer.hotel.location.city,
                    position: undefined
                  }
                ]
              }
            }
          })
        } catch (err) {}
        this.tracked = true
      }
    },
    base64EncodeUnicode(str) {
      // First we escape the string using encodeURIComponent to get the UTF-8 encoding of the characters,
      // then we convert the percent encodings into raw bytes, and finally feed it to btoa() function.
      const utf8Bytes = encodeURIComponent(str).replace(
        /%([0-9A-F]{2})/g,
        function(match, p1) {
          return String.fromCharCode('0x' + p1)
        }
      )

      return btoa(utf8Bytes)
    },
    trackClick() {
      window.dataLayer = window.dataLayer || []
      let pageType = 'undefined'
      if (window.dataLayer.length > 0) {
        if (window.dataLayer[0].hasOwnProperty('pageType')) {
          pageType = window.dataLayer[0].pageType
        }
      }
      try {
        window.dataLayer.push({
          event: 'promoClick',
          category: 'dealPromotion',
          action: 'conversion',
          label: 'automated|traveltainment|package|' + this.offer.offerId, // for example 'unifiedSearch|flight'
          value: undefined,
          ecommerce: {
            promoClick: {
              promotions: [
                {
                  id: this.offer.offerId,
                  name:
                    'automated|traveltainment|' +
                    pageType +
                    '|package|' +
                    this.offer.hotel.name, // for example 'unifiedSearch|flight'
                  creative:
                    this.offer.hotel.location.country +
                    ':' +
                    this.offer.hotel.location.region +
                    ':' +
                    this.offer.hotel.location.city,
                  position: undefined
                }
              ]
            }
          }
        })
      } catch (err) {}
      this.tracked = true
    }
  },
  filters: {
    formatDate(date) {
      return new Date(date).toLocaleDateString('de-de')
    }
  }
}
</script>
